import { axiosHrClient, axiosNotiClient } from '../plugins/axios'

const dashboard = {
  namespaced: true,

  state: {
    systemItem: [],
    favoriteList: [],
    loading: false,
    favLoading: false,
    tutorialDialog: false
  },

  mutations: {
    SET_SYSTEM_ITEM(state, data) {
      const favList = state.favoriteList
      let systemitems = data ? data : state.systemItem
      if (favList && favList.length > 0) {
        const fav = {}
        for (let key in favList) {
          fav[favList[key].programItemMenuID] = favList[key].sortOrder
        }
        for (let key in systemitems) {
          const foundFav = fav[systemitems[key].programItemMenuID]
          if (foundFav) {
            systemitems[key].favoriteSortOrder = foundFav
            // systemitems[key].notificationCount = 6
          } else {
            delete systemitems[key].favoriteSortOrder
          }
        }
      } else {
        for (let key in systemitems) {
          delete systemitems[key].favoriteSortOrder
        }
      }
      state.systemItem = systemitems
    },

    SET_FAVORITE_LIST(state, data) {
      state.favoriteList = data
    },

    SET_TUTORIAL_DIALOG(state, data) {
      state.tutorialDialog = data
    }
  },

  actions: {
    async getAllSystemItem({ state, commit, dispatch }) {
      state.loading = true
      try {
        await dispatch('getFavorite')

        const url = '/hrportal/self/systemitems'
        const response = await axiosHrClient.get(url)

        let systemitems = response.data.data || []
        await commit('SET_SYSTEM_ITEM', systemitems)

        return response
      } catch (e) {
        console.log(e.response || e)
        return e.response
      } finally {
        state.loading = false
      }
    },

    async getFavorite({ commit }) {
      try {
        const url = '/hrportal/self/favorite/0'
        const response = await axiosHrClient.get(url)
        const favList = response.data.data || []
        await commit('SET_FAVORITE_LIST', favList)
        await commit('SET_SYSTEM_ITEM')

        return response.data.data || []
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async setTutorialDialog({ commit }, payload) {
      try {
        await commit('SET_TUTORIAL_DIALOG', payload)
      } catch (e) {
        console.log(e.response || e)
      }
    },

    async updateFavoriteList({ state, dispatch }, payload) {
      state.favLoading = true
      try {
        const url = '/hrportal/self/managefavorite'
        const body = {
          ListFavoriteBodyModel: payload
        }
        const response = await axiosHrClient.post(url, body).then(async res => {
          if (res.data.message === 'success') {
            await dispatch('getFavorite')
          }
          return res
        })
        return response
      } catch (e) {
        console.log(e.response || e)
      } finally {
        state.favLoading = false
      }
    },

    getDashboards() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get('/hrportal/self/dashboards')
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getSelfPopup() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get('/hrportal/self/popups')
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postSelfPopup(ctx, body) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            '/hrportal/self/adduserpopupitems',
            body
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getSelfNoti() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosNotiClient.get('/Noti')
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postSelfNoti(ctx, body) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosNotiClient.post('/Noti', body)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getAppService() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosNotiClient.get('/Appservice')
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getAnnouncements() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get('/hrportal/Announcements')
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    postPinStatus(ctx, body) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            '/hrportal/adduserdashboarditems',
            body
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    updateFavOrder(ctx, body) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            '/hrportal/self/managefavorite',
            body
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  },

  getters: {
    getFavLoding: state => {
      return state.favLoading
    },

    getAllSystemItems: state => {
      return state.systemItem
    },

    getAllSystemItemsNotify: state => {
      return state.systemItem.filter(item => {
        return item.notificationCount ? item.notificationCount > 0 : false
      })
    },

    getAllSystemItemsFavorite: state => {
      return state.favoriteList
      // return state.systemItem.filter(item => {
      //   return !!item.favoriteSortOrder
      // })
    },

    getSystemItemByKeyword: state => keyword => {
      keyword = keyword.toLowerCase()
      return state.systemItem.filter(item => {
        return (
          item.itemFullNameEng?.toLowerCase().includes(keyword) ||
          item.itemFullNameTha?.toLowerCase().includes(keyword) ||
          item.itemDetailEng?.toLowerCase().includes(keyword) ||
          item.itemDetailTha?.toLowerCase().includes(keyword)
        )
      })
    }
  }
}

export default dashboard
